import { erroPeriodoConsulta } from '../../core/tools/periodo-consulta';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Animacao } from '../../core/tools/animacao';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

/* Services */

import { PdfService } from '../../core/tools/pdf.service';
import { RelatoriosService, ExportarPedidosRequest } from '../../core/services/relatorios/relatorios.service';
import { PedidoItensService } from '../../core/services/pedidos/pedido-itens.service';
import { PedidoService, PedidosPagedRequest } from '../../core/services/pedidos/pedido.service';
import { PedidoStatusService } from '../../core/services/pedidos/pedido-status.service';

/* Models */

import { Configuracao } from '../../core/models/configuracoes/configuracao';
import { Pedido } from '../../core/models/pedidos/pedido';
import { PedidoItensSintetico } from '../../core/models/pedidos/pedido-itens-sintetico';
import { PedidoPagamento } from '../../core/models/pedidos/pedido-pagamento';
import { PedidoSintetico } from '../../core/models/pedidos/pedido-sintetico';
import { PedidoStatus } from '../../core/models/pedidos/pedido-status';

@Component({
    selector: 'app-pedidos-enviados',
    templateUrl: './pedidos-enviados.component.html',
    styleUrls: ['./pedidos-enviados.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class PedidosEnviadosComponent implements OnInit {
  erroPeriodo = '';
  /* Carregamento */

  carregando: boolean = false;
  excelExportando: boolean = false;
  excelDiretoriaExportando: boolean = false;


  /* Filtros */

  formFiltro: UntypedFormGroup;

  filtroOpcoes: any[] = [
    { texto: "Período (Enviado)", valor: "0" },
    { texto: "Cliente", valor: "1" },
    { texto: "Nro Pedido", valor: "2" },
    { texto: "Status", valor: "3" }
  ];

  enviado: boolean = false;
  filtrado: boolean = false;

  /* Status */

  filtroStatus: any[] = [
    { texto: "Todos", valor: "Todos" },
    { texto: "À Integrar", valor: "À Integrar" },
    { texto: "Aguard Financeiro", valor: "Aguard Financeiro" },
    { texto: "Aguard Gerencial", valor: "Aguard Gerencial" },
    { texto: "Aguard Diretor", valor: "Aguard Diretor" },
    { texto: "Aguard Coordenador", valor: "Aguard Coordenador" },
    { texto: "Aguard Cad", valor: "Aguard Cad" },
    { texto: "Erro Integ", valor: "Erro Integ" },
    { texto: "Faturado", valor: "Faturado" },
    { texto: "Faturado Div", valor: "Faturado Div" },
    { texto: "Integrado", valor: "Integrado" },
    { texto: "Reprovado", valor: "Reprovado" }
  ];

  /* Configurações */

  @Input() configuracao: Configuracao;

  /* Fator Financeiro */

  exibirFatorFinanceiro: boolean = false;

  /* Ordernar (Pedidos) */

  ordernarPedidosOpcoes: any[] = [];

  ordernarPedidosOpcoesOrdem: any[] = [
    { texto: "Crescente", valor: "0" },
    { texto: "Decrescente", valor: "1" }
  ];

  ordernarPedidosSelecionado: string = "order_sent_on";
  ordernarPedidosOrdemSelecionado: string = "1";

  /* Paginação */

  page: number = 1;
  pageSize: number = 50;
  total: number = 0;
  totalPages: number = 0;

  /* Pedidos */

  pedidos: PedidoSintetico[] = [];
  pedidosOriginal: PedidoSintetico[] = [];

  pedidoAprovado: boolean = false;
  pedidoDesativado: boolean = false;
  pedidoReintegrado: boolean = false;
  pedidoReprovado: boolean = false;
  pedidoRetornado: boolean = false;

  pedidosItensSaldo: number = 0;

  /* Pedidos Itens */

  pedidosItens: PedidoItensSintetico[] = [];
  pedidosItensOriginal: PedidoItensSintetico[] = [];

  itemExpandido: number = -1;

  /* Pedidos (Pagamentos) */

  pedidoPagamento: PedidoPagamento = null;

  /* Pedidos (Status) */

  pedidosStatus: PedidoStatus[] = [];

  /* Reprovar */

  motivoReprovacao: string = "";

  /* Storage */

  is_master: boolean = (localStorage.getItem("is_master") == "true");
  is_manager: boolean = (localStorage.getItem("is_manager") == "true");
  is_master_seller: boolean = (localStorage.getItem("is_master_seller") == "true");
  is_diretor: boolean = (localStorage.getItem("is_diretor") == "true");
  is_financeiro: boolean = (localStorage.getItem("is_financeiro") == "true");
  aprovacao_pedido_nivel: string = (localStorage.getItem("aprovacao_pedido_nivel") || "").toUpperCase();
  modelo_tela_ligacoes: number = parseInt(localStorage.getItem("modelo_tela_ligacoes"));

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private pedidoItensService: PedidoItensService,
    private pedidoService: PedidoService,
    private pedidoStatusService: PedidoStatusService,
    private pdfService: PdfService,
    private relatoriosService: RelatoriosService
  ) { }

  ngOnDestroy() {
    this.modalService.dismissAll();
  }

  ngOnInit() {
    /* Filtros */

    this.formFiltro = this.formBuilder.group({
      filtro: ["0"],
      dt_inicial: [""],
      dt_final: [""],
      cliente: ["", Validators.required],
      nro_pedido: ["", Validators.required],
      status: ["Todos"],
      vendedor: [""],
      filtrar_b2b: [false],
      filtrar_cancelado: [false]
    });

    this.organizarFiltro();

    /* Ordenar */

    if (this.modelo_tela_ligacoes == 0) {
      /* Modelo 1 */

      this.ordernarPedidosOpcoes = [
        { texto: "Status", valor: "status_pedido" },
        { texto: "Nro Pedido", valor: "order_id_app" },
        { texto: "Vend Externo", valor: "vend_ext" },
        { texto: "Vend Interno", valor: "vend_int" },
        { texto: "Cliente", valor: "name" },
        { texto: "CNPJ/CPF", valor: "client_document" },
        { texto: "Total", valor: "total" },
        { texto: "Litragem", valor: "total_litragem" },
        { texto: "Faturado", valor: "total_fat" },
        { texto: "Enviado", valor: "order_sent_on" },
        { texto: "Liberado", valor: "dt_liberacao_master" },
        { texto: "Integrado", valor: "dt_integracao" },
        { texto: "Prazo Pagto", valor: "prazo_pgto" },
        { texto: "Tipo", valor: "cod_tipopedvenda" },
        { texto: "Nota Fiscal", valor: "numero_nf" }
      ];

      this.ordernarPedidosOrganizarOpcoes();
    }

    this.carregarDados(true);
  }

  get f() {
    return this.formFiltro.controls;
  }

  /* Ações */

  alterar(id_pedido: number, seller_id: number) {
    let pedido: Pedido = null;

    this.pedidoService.getByOrder(id_pedido, seller_id).subscribe(
      pedidos => pedido = pedidos,
      error => { console.log("Erro: " + error) },
      () => {
        if (pedido.order_sent_on == null) {
          this.router.navigate(["/pedidos-cadastro/" + id_pedido], {
            queryParams: {
              vendedor: seller_id
            }
          });
        } else {
          this.toastr.info("", "Tente novamente...");

          this.carregarDados(false);
        }
      }
    );
  }

  aprovar(id_pedido: number, seller_id: number) {
    let statusPedido: string;

    this.pedidoService.getStatusPedidoByOrder(id_pedido, seller_id).subscribe(
      statusPedidos => statusPedido = statusPedidos,
      error => { console.log("Erro: " + error) },
      () => {
        if (statusPedido == "Aguard Aprov" || statusPedido == "Aguard Financeiro") {
          this.pedidoService.aprovar(id_pedido, seller_id).subscribe(
            pedidoAprovado => this.pedidoAprovado = pedidoAprovado,
            error => { console.log("Erro: " + error) },
            () => {
              if (this.pedidoAprovado) {
                this.toastr.success("", "Pedido aprovado com sucesso!");
              } else {
                this.toastr.error("", "Erro ao realizar aprovação! Contate o suporte...");
              }
              this.carregarDados(false);
            }
          );
        } else {
          this.toastr.info("", "Tente novamente...");
          this.carregarDados(false);
        }
      }
    );
  }

  analisar(id_pedido: number, seller_id: number) {
    this.router.navigate(["/pedidos-cadastro/" + id_pedido], {
      queryParams: {
        aprovar: true,
        vendedor: seller_id
      }
    });
  }

  duplicar(id_pedido: number, seller_id: number) {
    this.router.navigate(["/pedidos-cadastro/" + id_pedido], {
      queryParams: {
        duplicar: true,
        vendedor: seller_id
      }
    });
  }

  integrar(id_pedido: number, seller_id: number) {
    /* Pedido Itens */

    let alterarPedido: boolean = false;

    this.pedidoService.updateDataIntegracaoByOrderIdApp(id_pedido, seller_id).subscribe(
      alterarPedidos => alterarPedido = alterarPedidos,
      error => { console.log("Erro: " + error) },
      () => {
        if (alterarPedido) {
          this.toastr.success("", "Pedido integrado com sucesso!");
        } else {
          this.toastr.error("", "Erro ao realizar integração! Contate o suporte...");
        }

        this.carregarDados(false);
      }
    );
  }

  reintegrar(id_pedido: number, seller_id: number) {
    let statusPedido: string;

    this.pedidoService.getStatusPedidoByOrder(id_pedido, seller_id).subscribe(
      statusPedidos => statusPedido = statusPedidos,
      error => { console.log("Erro: " + error) },
      () => {
        if (statusPedido == "À Integrar" || statusPedido == "Erro Integ") {
          this.pedidoService.reintegrar(id_pedido, seller_id).subscribe(
            pedidoReintegrado => this.pedidoReintegrado = pedidoReintegrado,
            error => { console.log("Erro: " + error) },
            () => {
              if (this.pedidoReintegrado) {
                this.toastr.success("", "Pedido reintegrado com sucesso!");
              } else {
                this.toastr.error("", "Erro ao realizar reintegração! Contate o suporte...");
              }

              this.carregarDados(false);
            }
          );
        } else {
          this.toastr.info("", "Tente novamente...");

          this.carregarDados(false);
        }
      }
    );
  }

  retornar(id_pedido: number, seller_id: number) {
    let statusPedido: string;

    this.pedidoService.getStatusPedidoByOrder(id_pedido, seller_id).subscribe(
      statusPedidos => statusPedido = statusPedidos,
      error => { console.log("Erro: " + error) },
      () => {
        if (statusPedido == "Erro Integ" || statusPedido == "Reprovado") {
          this.pedidoService.retornar(id_pedido, seller_id).subscribe(
            pedidoRetornado => this.pedidoRetornado = pedidoRetornado,
            error => { console.log("Erro: " + error) },
            () => {
              if (this.pedidoRetornado) {
                this.toastr.success("", "Pedido retornado com sucesso!");
              } else {
                this.toastr.error("", "Erro ao realizar retorno! Contate o suporte...");
              }

              this.carregarDados(false);
            }
          );
        } else {
          this.toastr.info("", "Tente novamente...");

          this.carregarDados(false);
        }
      }
    );
  }

  /* Dados */

  private buildPagedRequest(): PedidosPagedRequest {
    const f = this.formFiltro.controls;
    const rawIni = f['dt_inicial'].value;
    const rawFin = f['dt_final'].value;

    let dataInicio: string = null;
    let dataFim: string = null;

    if (rawIni && rawIni.year) {
      dataInicio = `${rawIni.year}-${String(rawIni.month).padStart(2, '0')}-${String(rawIni.day).padStart(2, '0')}`;
    }
    if (rawFin && rawFin.year) {
      dataFim = `${rawFin.year}-${String(rawFin.month).padStart(2, '0')}-${String(rawFin.day).padStart(2, '0')}`;
    }

    const filtroAtual: string = f['filtro'].value;

    return {
      page: this.page,
      pageSize: this.pageSize,
      sort: this.ordernarPedidosSelecionado || 'order_sent_on',
      direction: this.ordernarPedidosOrdemSelecionado === '0' ? 'asc' : 'desc',
      dataInicio: (filtroAtual === '0' || filtroAtual !== '0') ? dataInicio : null,
      dataFim: (filtroAtual === '0' || filtroAtual !== '0') ? dataFim : null,
      cliente: filtroAtual === '1' ? (f['cliente'].value || null) : null,
      nroPedido: filtroAtual === '2' ? (f['nro_pedido'].value ? +f['nro_pedido'].value : null) : null,
      status: filtroAtual === '3' && f['status'].value !== 'Todos' ? f['status'].value : null,
      vendedor: f['vendedor'].value || null,
      filtrarB2B: f['filtrar_b2b'].value || false,
      filtrarCancelado: f['filtrar_cancelado'].value || false,
    };
  }

  carregarDados(inicial: boolean) {
    this.erroPeriodo = erroPeriodoConsulta(this.formFiltro.controls['dt_inicial'].value, this.formFiltro.controls['dt_final'].value, true);
    if (this.erroPeriodo) return;
    this.carregando = true;
    this.itemExpandido = -1;

    const req = this.buildPagedRequest();

    this.pedidoService.getEnviadosPaged(req).subscribe(
      result => {
        this.pedidos = result ? result.items : [];
        const hasMore = result && result.hasMore ? result.hasMore : false;
        this.total = result && result.total ? result.total : 0;
        if (this.total > 0) {
          this.totalPages = this.pageSize > 0 ? Math.ceil(this.total / this.pageSize) : 0;
        } else {
          this.totalPages = hasMore ? this.page + 1 : this.page;
        }
        this.pedidosOriginal = [];

        if (this.pedidos.length > 0 && this.configuracao) {
          this.pedidos.forEach(item => {
            if (!this.configuracao.mostra_faturado && (item.status_pedido === 'Faturado' || item.status_pedido === 'Faturado Div')) {
              item.status_pedido = 'Integrado';
            }
          });
        }

        this.carregando = false;
      },
      error => {
        console.log('Erro: ' + error);
        this.carregando = false;
      }
    );
  }

  onPageChange(p: number) {
    this.page = p;
    this.carregarDados(false);
  }

  onPageSizeChange(n: number) {
    this.pageSize = n;
    this.page = 1;
    this.carregarDados(false);
  }

  reiniciarDados() {
    /* Mantido para compatibilidade com ordenação e filtros existentes */
    this.pedidos = JSON.parse(JSON.stringify(this.pedidosOriginal));
  }

  /* Expandir */

  expandir(i: number, id: number, seller_id: number) {
    this.exibirFatorFinanceiro = false;

    this.itemExpandido = i == this.itemExpandido ? -1 : i;

    this.pedidosItensSaldo = 0;

    if (this.itemExpandido > -1) {
      this.pedidoItensService.get15DiasByOrder(id, seller_id).subscribe(
        pedidosItens => this.pedidosItens = pedidosItens,
        error => { console.log("Erro: " + error) },
        () => {
          if (this.pedidosItens.length > 0) {
            this.pedidosItensSaldo = this.pedidosItens.reduce((sum, current) => sum + current.valor_desconto, 0);

            this.pedidosItensOriginal = JSON.parse(JSON.stringify(this.pedidosItens));

            let qtdeProdutosFatorFinanceiro: number = this.pedidosItens.filter(pedidoItem => pedidoItem.fator_financeiro != null && pedidoItem.fator_financeiro != 0).length;

            if (qtdeProdutosFatorFinanceiro > 0) {
              this.exibirFatorFinanceiro = true;
            }
          } else {
            this.pedidosItensOriginal = [];
          }
        }
      );
    }
  }

  /* Filtros */

  alterarFiltro(filtro_selecionado: string) {
    let filtroAtual: string = this.formFiltro.controls["filtro"].value;
    let filtroB2BAtual: boolean = this.formFiltro.controls["filtrar_b2b"].value
    let filtroCanceladoAtual: boolean = this.formFiltro.controls["filtrar_cancelado"].value;

    this.formFiltro.reset();

    if (filtro_selecionado == null) {
      this.formFiltro.controls["filtro"].setValue(filtroAtual);
      this.formFiltro.controls["filtrar_b2b"].setValue(false);
      this.formFiltro.controls["filtrar_cancelado"].setValue(false);
    } else {
      this.formFiltro.controls["filtro"].setValue(filtro_selecionado);
      this.formFiltro.controls["filtrar_b2b"].setValue(filtroB2BAtual);
      this.formFiltro.controls["filtrar_cancelado"].setValue(filtroCanceladoAtual);
    }

    this.formFiltro.controls["status"].setValue("Todos");
    this.formFiltro.controls["filtrar_b2b"].setValue(filtroB2BAtual);

    this.organizarFiltro();

    this.enviado = false;
    this.filtrado = false;
  }

  filtrar(formulario: boolean) {
    if (formulario) {
      this.enviado = true;
      if (this.formFiltro.invalid) {
        return;
      }
    }

    this.filtrado = true;
    this.page = 1;
    this.carregarDados(false);
  }

  filtrarB2B() {
    this.page = 1;
    this.carregarDados(false);
  }

  filtrarCancelado() {
    this.page = 1;
    this.carregarDados(false);
  }

  organizarFiltro() {
    if (this.formFiltro.controls["filtro"].value == "0") {
      /* Período (Enviado) */

      this.formFiltro.get("dt_inicial").enable();
      this.formFiltro.get("dt_final").enable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("nro_pedido").disable();
      this.formFiltro.get("status").disable();
    } else if (this.formFiltro.controls["filtro"].value == "1") {
      /* Cliente */

      this.formFiltro.get("dt_inicial").enable();
      this.formFiltro.get("dt_final").enable();
      this.formFiltro.get("cliente").enable();
      this.formFiltro.get("nro_pedido").disable();
      this.formFiltro.get("status").disable();
    } else if (this.formFiltro.controls["filtro"].value == "2") {
      /* Nro Pedido */

      this.formFiltro.get("dt_inicial").enable();
      this.formFiltro.get("dt_final").enable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("nro_pedido").enable();
      this.formFiltro.get("status").disable();
    } else if (this.formFiltro.controls["filtro"].value == "3") {
      /* Status */

      this.formFiltro.get("dt_inicial").enable();
      this.formFiltro.get("dt_final").enable();
      this.formFiltro.get("cliente").disable();
      this.formFiltro.get("nro_pedido").disable();
      this.formFiltro.get("status").enable();
    }
  }

  /* Formatação */

  formatarValoresQuatroCasasDecimais(valor: number) {
    if (valor != null) {
      return (valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 4
      });
    }
  }

  /* Imprimir */

  imprimir(id_pedido: number, seller_id: number) {
    this.pdfService.imprimirPedidoOrcamento(id_pedido, seller_id, 0);
  }

  /* Modal */

  modalConsultarPagamento(content: any, id: number) {
    /* Pedidos (Pagamentos) */

    this.pedidoService.getPedidoPagamentoById(id).subscribe(
      pedidoPagamento => this.pedidoPagamento = pedidoPagamento,
      error => { console.log("Erro: " + error) },
      () => {
        this.modalService.open(content, {
          ariaLabelledBy: "titulo-consultar-pagamento",
          size: "lg",
          backdrop: "static"
        });
      }
    );
  }

  modalPedidoReprovar(content: any, id_pedido: number, seller_id: number) {
    let statusPedido: string;

    this.pedidoService.getStatusPedidoByOrder(id_pedido, seller_id).subscribe(
      statusPedidos => statusPedido = statusPedidos,
      error => { console.log("Erro: " + error) },
      () => {
        if (statusPedido == "Aguard Aprov" || statusPedido == "Aguard Financeiro") {
          this.motivoReprovacao = "";

          this.modalService.open(content, {
            ariaLabelledBy: "titulo-pedido-reprovar",
            size: "lg",
            backdrop: "static"
          }).result.then((acao) => {
            if (acao == "Salvar") {
              this.pedidoService.reprovar(id_pedido, seller_id, this.motivoReprovacao).subscribe(
                pedidoReprovado => this.pedidoReprovado = pedidoReprovado,
                error => { console.log("Erro: " + error) },
                () => {
                  if (this.pedidoReprovado) {
                    this.toastr.success("", "Pedido reprovado com sucesso!");
                  } else {
                    this.toastr.error("", "Erro ao realizar reprovação! Contate o suporte...");
                  }

                  this.carregarDados(false);
                }
              );
            }
          }, () => {

          });
        } else {
          this.toastr.info("", "Tente novamente...");

          this.carregarDados(false);
        }
      }
    );
  }

  /* Financeiro */

  private temNivelAprovacaoConfigurado(): boolean {
    return this.aprovacao_pedido_nivel != null && this.aprovacao_pedido_nivel.trim() !== "";
  }

  private isPendenteGestor(pedido: any): boolean {
    if (pedido.status_aprovacao_gestor != null) {
      return pedido.status_aprovacao_gestor === "P";
    }

    return pedido.status_pedido === "Aguard Coordenador";
  }

  private isPendenteDiretor(pedido: any): boolean {
    if (pedido.status_aprovacao_diretor != null) {
      return pedido.status_aprovacao_diretor === "P";
    }

    return pedido.status_pedido === "Aguard Diretor";
  }

  private isPendenteMaster(pedido: any): boolean {
    if (pedido.status_aprovacao_master != null) {
      return pedido.status_aprovacao_master === "P";
    }

    return pedido.status_pedido === "Aguard Gerencial" || pedido.status_pedido === "Aguard Aprov";
  }

  private isStatusAprovacaoPedido(pedido: any): boolean {
    return pedido.status_pedido === "Aguard Gerencial"
      || pedido.status_pedido === "Aguard Diretor"
      || pedido.status_pedido === "Aguard Coordenador"
      || pedido.status_pedido === "Aguard Aprov";
  }

  private podeAprovarPedidoRegraAtual(pedido: any): boolean {
    return this.is_master
      || (this.is_diretor && pedido.status_aprovacao_diretor === "P")
      || (this.is_manager && pedido.status_aprovacao_gestor === "P" && pedido.aprovacao_master !== "P");
  }

  podeAprovarPedido(pedido: any): boolean {
    if (!pedido) return false;

    if (pedido.status_pedido === "Aguard Financeiro") {
      return this.podeFinanceiroAprovar(pedido);
    }

    if (!this.isStatusAprovacaoPedido(pedido)) {
      return false;
    }

    if (!this.temNivelAprovacaoConfigurado()) {
      return this.podeAprovarPedidoRegraAtual(pedido);
    }

    switch (this.aprovacao_pedido_nivel) {
      case "IS_MANAGER":
        return pedido.status_pedido === "Aguard Coordenador"
          || (pedido.status_pedido === "Aguard Aprov" && this.isPendenteGestor(pedido) && pedido.aprovacao_master !== "P");
      case "IS_DIRETOR":
        return pedido.status_pedido === "Aguard Diretor"
          || (pedido.status_pedido === "Aguard Aprov" && this.isPendenteDiretor(pedido));
      case "IS_MASTER":
        return this.isPendenteMaster(pedido) || this.isPendenteGestor(pedido) || this.isPendenteDiretor(pedido);
      case "IS_FINANCEIRO":
        return false;
      default:
        return this.podeAprovarPedidoRegraAtual(pedido);
    }
  }

  podeFinanceiroAprovar(pedido: any): boolean {
    if (!pedido) return false;

    const podeAprovarFinanceiro = this.temNivelAprovacaoConfigurado()
      ? this.aprovacao_pedido_nivel === "IS_FINANCEIRO"
      : this.is_financeiro;

    if (podeAprovarFinanceiro) {
      if (pedido.status_aprovacao_financeiro != null) {
        return pedido.status_aprovacao_financeiro === "P";
      }

      return true;
    }

    return false;
  }

  modalPedidoStatus(content: any, id_pedido: number) {
    /* Pedidos (Status) */

    this.pedidoStatusService.getPedidoStatusByOrder(id_pedido).subscribe(
      pedidosStatus => this.pedidosStatus = pedidosStatus,
      error => { console.log("Erro: " + error) },
      () => {
        this.modalService.open(content, {
          ariaLabelledBy: "titulo-pedido-status",
          size: "lg",
          backdrop: "static"
        });
      }
    );
  }

  /* Ordenar (Pedidos) */

  ordernarPedidos(opcao_selecionada: string) {
    this.ordernarPedidosSelecionado = opcao_selecionada;

    switch (this.ordernarPedidosOrdemSelecionado) {
      case "0":
        /* Crescente */

        this.pedidosOriginal.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a[this.ordernarPedidosSelecionado], b[this.ordernarPedidosSelecionado]);
        });

        break;
      case "1":
        /* Decrescente */

        this.pedidosOriginal.sort((a, b) => {
          const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

          return compare(a[this.ordernarPedidosSelecionado], b[this.ordernarPedidosSelecionado]) * -1; /* Decrescente */
        });

        break;
      default:

    }

    this.pedidos = JSON.parse(JSON.stringify(this.pedidosOriginal));

    if (this.filtrado) {
      this.filtrar(false);
    }
  }

  ordernarPedidosOrdem(opcao_selecionada: string) {
    this.ordernarPedidosOrdemSelecionado = opcao_selecionada;

    this.ordernarPedidos(this.ordernarPedidosSelecionado);
  }

  ordernarPedidosOrganizarOpcoes() {
    this.ordernarPedidosOpcoes.sort((a, b) => {
      const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

      return compare(a["texto"], b["texto"]);
    });
  }

  /* Exportar Excel */

  private buildExportPayload(tipoRelatorio: string): ExportarPedidosRequest {
    const req = this.buildPagedRequest();
    return {
      userId: parseInt(localStorage.getItem('id'), 10),
      tipoRelatorio,
      tela: 'ENVIADOS',
      dataInicio: req.dataInicio || null,
      dataFim:    req.dataFim    || null,
      cliente:    req.cliente    || null,
      nroPedido:  req.nroPedido  || null,
      status:     req.status     || null,
      vendedor:   req.vendedor   || null,
      filtrarB2B:       req.filtrarB2B       || false,
      filtrarCancelado: req.filtrarCancelado || false
    };
  }

  exportarExcel() {
    this.erroPeriodo = erroPeriodoConsulta(this.formFiltro.controls['dt_inicial'].value, this.formFiltro.controls['dt_final'].value, true);
    if (this.erroPeriodo) return;
    if (this.pedidos.length === 0 || this.excelExportando) { return; }
    this.excelExportando = true;
    const payload = this.buildExportPayload('GERAL');
    this.relatoriosService.exportarExcel(payload).subscribe(
      blob => {
        if (blob) {
          const sufixo = payload.dataInicio
            ? `${payload.dataInicio.replace(/-/g,'')}_${(payload.dataFim || '').replace(/-/g,'')}`
            : new Date().toISOString().slice(0, 10).replace(/-/g, '');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url; a.download = `pedidos-enviados-geral_${sufixo}.xlsx`; a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      error => { console.error('Erro ao exportar Excel', error); },
      ()    => { this.excelExportando = false; }
    );
  }

  exportarExcelDiretoria() {
    this.erroPeriodo = erroPeriodoConsulta(this.formFiltro.controls['dt_inicial'].value, this.formFiltro.controls['dt_final'].value, true);
    if (this.erroPeriodo) return;
    if (this.pedidos.length === 0 || this.excelDiretoriaExportando) { return; }
    this.excelDiretoriaExportando = true;
    const payload = this.buildExportPayload('DIRETORIA');
    this.relatoriosService.exportarExcel(payload).subscribe(
      blob => {
        if (blob) {
          const sufixo = payload.dataInicio
            ? `${payload.dataInicio.replace(/-/g,'')}_${(payload.dataFim || '').replace(/-/g,'')}`
            : new Date().toISOString().slice(0, 10).replace(/-/g, '');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url; a.download = `pedidos-enviados-diretoria_${sufixo}.xlsx`; a.click();
          window.URL.revokeObjectURL(url);
        }
      },
      error => { console.error('Erro ao exportar Excel Diretoria', error); },
      ()    => { this.excelDiretoriaExportando = false; }
    );
  }
}
